import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Link, useParams } from "react-router-dom";
import { getPaymentReceiptCustomerView } from "../services/reports.services";
import NoDataFoundPage from "../../../components/common/NoDataFoundPage";
import { LoadingPanel } from "../../../components/layout/Loading";
// import Logo from "../../../assets/Images/logo.png";

const PaymentReceiptCustomerReport: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const PaymentReceipt_GUID = params?.PaymentReceipt_GUID;
  // const CompanyID = params?.CompanyID;
  const loading = useAppSelector((state) => state.reports.loading);
  const PaymentReceiptCustomerDetails = useAppSelector(
    (state) => state.reports.PaymentReceiptCustomerDetails,
  );
  const CompanyDetail = PaymentReceiptCustomerDetails?.CompanyDetails;

  useEffect(() => {
    if (PaymentReceipt_GUID) {
      dispatch(
        getPaymentReceiptCustomerView({
          PaymentReceipt_GUID: PaymentReceipt_GUID,
        }),
      );
    }
  }, [PaymentReceipt_GUID]);

  const handleBookingLinkClick = (PBNNo: any) => {
    // const url = REACT_APP_URL + "/tourbookingdetails/" + PBNNo;
    window.open(
      "/tourbookingdetails/" + PBNNo,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const createNotes = (Notes: any) => {
    return {
      __html: Notes,
    };
  };
  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {PaymentReceiptCustomerDetails &&
      PaymentReceiptCustomerDetails?.PaymentReceiptNo ? (
        <div
          className="container-fluid p-5 payment-receipt-table payment-receipt-print"
          // style={{ fontSize: 12 }}
        >
          <div className="row">
            <div className="col-2 d-flex align-items-center">
              <img src={CompanyDetail?.CompanyLogo} alt="" width="100%" />
            </div>
            <div className="col-7" style={{ borderLeft: "1px solid black" }}>
              <h5 className="fw-600">{CompanyDetail?.CompanyName}</h5>
              <div className="d-flex" style={{ gap: 100 }}>
                <span>
                  <span className="fw-600">GST : </span> {CompanyDetail?.GSTNo}
                </span>
              </div>
              <div className="d-flex" style={{ gap: 100 }}>
                <span>
                  <span className="fw-600">PAN : </span> {CompanyDetail?.PANNo}
                </span>
              </div>
              <div className="d-flex" style={{ gap: 100 }}>
                <span>
                  <span className="fw-600">Mobile : </span>{" "}
                  {CompanyDetail?.MobileNo}
                </span>
              </div>
              <div>
                <span className="fw-600">Email : </span>{" "}
                {CompanyDetail?.EmailID}
              </div>
            </div>
            <div
              className="col-3"
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {CompanyDetail?.Address} <br />
              {CompanyDetail?.CityName} - {CompanyDetail?.Pincode} <br />
              State: {CompanyDetail?.StateName} <br />
              Country: {CompanyDetail?.CountryName}
            </div>
          </div>
          <table className="w-100 fw-600">
            <div style={{ pageBreakAfter: "always" }}>
              <table className="mt-2 passenger-table w-100">
                <thead>
                  <tr className="title-b text-center table-blue bg-dark">
                    <td className="w-100 text-white p-1" colSpan={25}>
                      <h5 className="m-0">Payment Receipt</h5>
                    </td>
                  </tr>
                  <tr className="secondary-bg-color text-center">
                    <td>Tour Booking No</td>
                    <td>Receipt No</td>
                    <td>Date</td>
                    {/* <td>Branch</td> */}
                    <td>Created By</td>
                    <td colSpan={2}>Customer PAN No</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td>
                      <Link
                        to="#"
                        style={{ textDecoration: "none" }}
                        onClick={() =>
                          handleBookingLinkClick(
                            PaymentReceiptCustomerDetails?.TourBookingNo,
                          )
                        }
                      >
                        {PaymentReceiptCustomerDetails.TourBookingNo}
                      </Link>
                    </td>
                    <td>{PaymentReceiptCustomerDetails.PaymentReceiptNo}</td>
                    <td>{PaymentReceiptCustomerDetails.PaymentDate}</td>
                    {/* <td>{PaymentReceiptCustomerDetails.BranchName}</td> */}
                    <td>{PaymentReceiptCustomerDetails.BookByName}</td>
                    <td colSpan={2}>{PaymentReceiptCustomerDetails.PANNo}</td>
                  </tr>
                  <tr className="text-start">
                    <td colSpan={1}>
                      <span>Name:</span>
                    </td>
                    <td colSpan={5}>
                      <span>{PaymentReceiptCustomerDetails.GuestName}</span>
                    </td>
                  </tr>
                  <tr className="text-start">
                    <td colSpan={1}>
                      <span>Address:</span>
                    </td>
                    <td colSpan={5}>
                      <span>{PaymentReceiptCustomerDetails.Address}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="mt-3 passenger-table w-100">
                <thead>
                  <tr className="secondary-bg-color text-center">
                    <td>No</td>
                    <td>Start to End Date</td>
                    {/* <td>Tour Code</td> */}
                    <td>Total Pax</td>
                    <td>Payment Mode</td>
                    <td>Amount</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="text-center">
                    <td>1</td>
                    <td>{PaymentReceiptCustomerDetails?.StartEndDate}</td>
                    {/* <td>{PaymentReceiptCustomerDetails?.TourDateCode}</td> */}
                    <td>{PaymentReceiptCustomerDetails?.TotalNoOfPax}</td>
                    <td>{PaymentReceiptCustomerDetails?.PaymentType}</td>
                    <td>{PaymentReceiptCustomerDetails?.Amount}</td>
                  </tr>
                  <tr className="text-end">
                    <td colSpan={5}>
                      <span className="title-b pr-10">Amount : </span>
                      <span className=" pr-10">
                        {PaymentReceiptCustomerDetails?.Amount}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={5}>
                      <div
                        style={{ minHeight: 20 }}
                        dangerouslySetInnerHTML={createNotes(
                          PaymentReceiptCustomerDetails.Notes,
                        )}
                      ></div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </table>
        </div>
      ) : (
        <NoDataFoundPage />
      )}
    </>
  );
};

export default PaymentReceiptCustomerReport;
